import { useT } from '@planetra/i18n';
import { Skeleton, VisuallyHidden } from '@planetra/ui';

/**
 * Suspense fallback while a lazy route module downloads.
 *
 * Skeletons rather than a spinner, and every one of them with an explicit
 * size: WS-8 forbids layout shift on data arrival, so the placeholder has to
 * occupy the space the route will. The status region is what actually gets
 * announced — the skeletons themselves are aria-hidden, because a screen
 * reader reading out four grey boxes is worse than silence.
 */
export function RouteFallback() {
  const { t } = useT();

  return (
    <div className="flex flex-col gap-3 p-6" aria-busy="true">
      <VisuallyHidden role="status">{t('common:loading')}</VisuallyHidden>
      <Skeleton width="16rem" height="1.75rem" />
      <Skeleton width="100%" height="1rem" />
      <Skeleton width="80%" height="1rem" />
      <Skeleton width="60%" height="1rem" />
    </div>
  );
}
